import { useCallback, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { usePatient } from "Components/usePatientContext"
import api from 'lib/api_clinica'
import { toast } from "react-toastify"

const input = {
    name: 'idEspecialidade',
    label: 'descricaoEspecialidade'
}

export default function useEspecialidades() {

    const [ loading, setLoading  ] = useState([])

    const [ data , setData  ] = useState([])

    const [ open , setOpen  ] = useState(false)

    const selected = useRef()

    const { 
        setPatient, 
        setRedirect,
        patient 
    } = usePatient()

    const navigate = useNavigate()

    const nextStage = useCallback(() => {
        const item = selected.current
        setPatient( prevState => { 
            return {
                ...prevState, 
                    [input.name]: item[input.name], 
                    descricaoEspecialidade: item.descricaoEspecialidade, 
            } 
        })

        setRedirect('/dia')

    }, [ setPatient, setRedirect ])

    const selectItem = useCallback( item => {

        selected.current = item

        if (item?.ativo === 0) {
            setOpen(true)
        } else {
            nextStage()
        }

    }, [ nextStage, setOpen ])

    const onLoad = useCallback( async () => { 

        try {

            const idConvenio = patient.idConvenio
            
            setLoading(true)
            const especialidades = await api.especialidades.get(idConvenio)
            setData(especialidades)

        } catch (error) {
            console.log(error)
            toast.error('Ocorreu um erro ao listar as especialidades')  
        } finally {
            setLoading(false)
        }
        
    }, [ setData, setLoading, patient.idConvenio ])

    const onConfirm = () => {
        navigate('/central-agendamento', { replace: true })
    }

    const onBack = useCallback(() => {
        setPatient( prevState => ({ ...prevState, idConvenio: '' }) )
    }, [setPatient])

    return {
        onLoad,
        loading,
        data,
        open,
        selectItem,
        onConfirm,
        onBack

    }
}